import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { SelectionGroup, SelectionGroupItem, Typography } from 'fronton-react';
import { useBreakpoints } from 'common/hooks/use-breakpoints';
import { WallHorizontal, WallDiagonal } from 'assets';
import { LayingType, LayingTypeCalculationPercentage, LayingTypeLabel } from './const';
import {
  ButtonContainer,
  HeaderContainer,
  LayerContainer,
  LayerThickness,
  SelectionGroupClassname,
  SelectionGroupItemClassname,
  ButtonLabelsWrapper,
  LayingTypeLabelWrapper,
  AdditionalMaterialWrapper,
} from './styles';

const defaultLayingTypes = [
  {
    name: LayingType.horizontal,
    label: LayingTypeLabel[LayingType.horizontal],
    calculationPercentage: `${LayingTypeCalculationPercentage[LayingType.horizontal]} запас материала`,
    getIcon: () => <WallHorizontal />,
  },
  {
    name: LayingType.diagonal,
    label: LayingTypeLabel[LayingType.diagonal],
    calculationPercentage: `${LayingTypeCalculationPercentage[LayingType.diagonal]} запас материала`,
    getIcon: () => <WallDiagonal />,
  },
];

type TLayingType = {
  name: string;
  label: string;
  calculationPercentage: string;
  getIcon: () => React.JSX.Element;
};

type TProps = {
  fieldName: string;
  onChangeValue?: () => void;
  header?: string;
  layingTypes?: TLayingType[];
};

export const LayingTypeField = ({
  fieldName,
  onChangeValue,
  header = 'Направление укладки',
  layingTypes = defaultLayingTypes,
}: TProps) => {
  const { control, setValue } = useFormContext();
  const { mobile } = useBreakpoints() ?? {};
  return (
    <>
      <ButtonContainer>
        <HeaderContainer>
          <Typography variant="h3" color="text-primary">
            {header}
          </Typography>
        </HeaderContainer>
      </ButtonContainer>
      <LayerContainer>
        <Controller
          name={fieldName}
          control={control}
          render={({ field: { onChange, value } }) => (
            <SelectionGroup
              active={value}
              onChange={(_, layingTypeValue) => {
                onChange();
                setValue(fieldName, layingTypeValue);
                onChangeValue?.();
              }}
              variant="outline"
              size={mobile ? 's' : 'm'}
              className={SelectionGroupClassname}>
              {layingTypes.map(layingTypeItem => (
                <SelectionGroupItem
                  className={SelectionGroupItemClassname}
                  key={layingTypeItem.name}
                  value={layingTypeItem.name}
                  data-testid={`${layingTypeItem.name}-laying-type-select`}>
                  <LayerThickness>
                    {layingTypeItem.getIcon()}
                    <ButtonLabelsWrapper>
                      <LayingTypeLabelWrapper>
                        <Typography variant="m" size="body_long" color="text-primary">
                          {layingTypeItem.label}
                        </Typography>
                      </LayingTypeLabelWrapper>
                      <AdditionalMaterialWrapper>
                        <Typography size="body_long" variant="s" color="text-secondary">
                          {layingTypeItem.calculationPercentage}
                        </Typography>
                      </AdditionalMaterialWrapper>
                    </ButtonLabelsWrapper>
                  </LayerThickness>
                </SelectionGroupItem>
              ))}
            </SelectionGroup>
          )}
        />
      </LayerContainer>
    </>
  );
};
